{
  "add-experience": {
    "en": "Add Experience",
    "ar": "إضافة خبرة",
    "id": "Tambah Pengalaman"
  },
  "update-experience": {
    "en": "Update Experience",
    "ar": "تحديث الخبرة",
    "id": "Perbarui Pengalaman"
  },
  "add-experience-details": {
    "en": "Add your experience details",
    "ar": "أضف تفاصيل خبرتك",
    "id": "Tambahkan detail pengalaman Anda"
  },
  "update-experience-details": {
    "en": "Update your experience details",
    "ar": "حدث تفاصيل خبرتك",
    "id": "Perbarui detail pengalaman Anda"
  },
  "title": {
    "en": "Title",
    "ar": "المسمى الوظيفي",
    "id": "Jabatan"
  },
  "title-placeholder": {
    "en": "Ex: Retail Sales Manager",
    "ar": "مثال: مدير مبيعات التجزئة",
    "id": "Contoh: Manajer Penjualan Ritel"
  },
  "employment-type": {
    "en": "Employment Type",
    "ar": "نوع التوظيف",
    "id": "Jenis Pekerjaan"
  },
  "work-arrangement": {
    "en": "Work Arrangement",
    "ar": "ترتيب العمل",
    "id": "Pengaturan Kerja"
  },
  "company-or-organization": {
    "en": "Company or organization",
    "ar": "الشركة أو المنظمة",
    "id": "Perusahaan atau organisasi"
  },
  "company-placeholder": {
    "en": "Ex: Microsoft",
    "ar": "مثال: مايكروسوفت",
    "id": "Contoh: Microsoft"
  },
  "currently-working": {
    "en": "I am currently working in this role",
    "ar": "أعمل حالياً في هذا المنصب",
    "id": "Saya saat ini bekerja di posisi ini"
  },
  "start-date": {
    "en": "Start Date",
    "ar": "تاريخ البدء",
    "id": "Tanggal Mulai"
  },
  "end-date": {
    "en": "End Date",
    "ar": "تاريخ الانتهاء",
    "id": "Tanggal Selesai"
  },
  "description": {
    "en": "Description (Optional)",
    "ar": "الوصف (اختياري)",
    "id": "Deskripsi (Opsional)"
  },
  "description-placeholder": {
    "en": "Write description about your detail job",
    "ar": "اكتب وصفاً عن تفاصيل عملك",
    "id": "Tulis deskripsi tentang detail pekerjaan Anda"
  },
  "please-select": {
    "en": "Please Select",
    "ar": "يرجى الاختيار",
    "id": "Silakan Pilih"
  },
  "cancel": {
    "en": "Cancel",
    "ar": "إلغاء",
    "id": "Batal"
  },
  "add": {
    "en": "Add",
    "ar": "إضافة",
    "id": "Tambah"
  },
  "update": {
    "en": "Update",
    "ar": "تحديث",
    "id": "Perbarui"
  },
  "loading": {
    "en": "Loading...",
    "ar": "جاري التحميل...",
    "id": "Memuat..."
  },
  "save": {
    "en": "Save",
    "ar": "حفظ",
    "id": "Simpan"
  },
  "validation-title-min": {
    "en": "Title must be at least 2 characters",
    "ar": "يجب أن يكون المسمى الوظيفي على الأقل حرفين",
    "id": "Jabatan minimal 2 karakter"
  },
  "validation-description-min": {
    "en": "Description must be at least 10 characters",
    "ar": "يجب أن يكون الوصف على الأقل 10 أحرف",
    "id": "Deskripsi minimal 10 karakter"
  },
  "validation-start-date-required": {
    "en": "Start date is required",
    "ar": "تاريخ البدء مطلوب",
    "id": "Tanggal mulai wajib diisi"
  },
  "validation-company-min": {
    "en": "Company name must be at least 2 characters",
    "ar": "يجب أن يكون اسم الشركة على الأقل حرفين",
    "id": "Nama perusahaan minimal 2 karakter"
  },
  "validation-employment-type-required": {
    "en": "Employment type is required",
    "ar": "نوع التوظيف مطلوب",
    "id": "Jenis pekerjaan wajib diisi"
  },
  "validation-work-arrangement-required": {
    "en": "Work arrangement is required",
    "ar": "ترتيب العمل مطلوب",
    "id": "Pengaturan kerja wajib diisi"
  },
  "validation-end-date-required": {
    "en": "End date is required when not current role",
    "ar": "تاريخ الانتهاء مطلوب عندما لا يكون المنصب الحالي",
    "id": "Tanggal selesai wajib diisi jika bukan posisi saat ini"
  },
  "education": {
    "en": "Education",
    "ar": "التعليم",
    "id": "Pendidikan"
  },
  "diploma": {
    "en": "Diploma",
    "ar": "دبلوم",
    "id": "Diploma"
  },
  "highschool": {
    "en": "High school",
    "ar": "الثانوية العامة",
    "id": "SMA"
  },
  "bachelor": {
    "en": "Bachelor",
    "ar": "بكالوريوس",
    "id": "Sarjana"
  },
  "select-education-type": {
    "en": "Select education type",
    "ar": "اختر نوع التعليم",
    "id": "Pilih jenis pendidikan"
  },
  "add-information": {
    "en": "Add information",
    "ar": "إضافة معلومات",
    "id": "Tambah informasi"
  },
  "skills": {
    "en": "Skills",
    "ar": "المهارات",
    "id": "Keterampilan"
  },
  "no-skills-available": {
    "en": "No skills available",
    "ar": "لا توجد مهارات متاحة",
    "id": "Tidak ada keterampilan tersedia"
  },
  "skill-rating-updated": {
    "en": "Skill rating updated successfully",
    "ar": "تم تحديث تقييم المهارة بنجاح",
    "id": "Peringkat keterampilan berhasil diperbarui"
  },
  "failed-update-skill-rating": {
    "en": "Failed to update skill rating",
    "ar": "فشل تحديث تقييم المهارة",
    "id": "Gagal memperbarui peringkat keterampilan"
  },
  "rate-stars": {
    "en": "Rate {count} stars",
    "ar": "تقييم {count} نجوم",
    "id": "Beri {count} bintang"
  },
  "stars": {
    "en": "{count} stars",
    "ar": "{count} نجوم",
    "id": "{count} bintang"
  },
  "languages": {
    "en": "Languages you speak",
    "ar": "اللغات التي تتحدثها",
    "id": "Bahasa yang Anda kuasai"
  },
  "no-languages-available": {
    "en": "No languages available",
    "ar": "لا توجد لغات متاحة",
    "id": "Tidak ada bahasa tersedia"
  },
  "language-rating-updated": {
    "en": "Language rating updated successfully",
    "ar": "تم تحديث تقييم اللغة بنجاح",
    "id": "Peringkat bahasa berhasil diperbarui"
  },
  "failed-update-language-rating": {
    "en": "Failed to update language rating",
    "ar": "فشل تحديث تقييم اللغة",
    "id": "Gagal memperbarui peringkat bahasa"
  },
  "add-education": {
    "en": "Add Education",
    "ar": "إضافة تعليم",
    "id": "Tambah Pendidikan"
  },
  "update-education": {
    "en": "Update Education",
    "ar": "تحديث التعليم",
    "id": "Perbarui Pendidikan"
  },
  "add-education-details": {
    "en": "Add your education details",
    "ar": "أضف تفاصيل تعليمك",
    "id": "Tambahkan detail pendidikan Anda"
  },
  "update-education-details": {
    "en": "Update your education details",
    "ar": "حدث تفاصيل تعليمك",
    "id": "Perbarui detail pendidikan Anda"
  },
  "university": {
    "en": "University",
    "ar": "الجامعة",
    "id": "Universitas"
  },
  "university-placeholder": {
    "en": "Ex: Harvard University",
    "ar": "مثال: جامعة هارفارد",
    "id": "Contoh: Universitas Harvard"
  },
  "degree": {
    "en": "Degree",
    "ar": "الدرجة العلمية",
    "id": "Gelar"
  },
  "degree-placeholder": {
    "en": "Ex: Bachelor of Science",
    "ar": "مثال: بكالوريوس علوم",
    "id": "Contoh: Sarjana Sains"
  },
  "field-of-study": {
    "en": "Field of Study (Optional)",
    "ar": "مجال الدراسة",
    "id": "Bidang Studi"
  },
  "field-of-study-placeholder": {
    "en": "Ex: Computer Science",
    "ar": "مثال: علوم الحاسوب",
    "id": "Contoh: Ilmu Komputer"
  },
  "activities-optional": {
    "en": "Activities and Societies (Optional)",
    "ar": "الأنشطة والجمعيات (اختياري)",
    "id": "Aktivitas dan Organisasi (Opsional)"
  },
  "activities-placeholder": {
    "en": "Ex: Student Government, Chess Club",
    "ar": "مثال: مجلس الطلاب، نادي الشطرنج",
    "id": "Contoh: Organisasi Mahasiswa, Klub Catur"
  },
  "location": {
    "en": "Location",
    "ar": "الموقع",
    "id": "Lokasi"
  },
  "location-placeholder": {
    "en": "Ex: Cambridge, MA",
    "ar": "مثال: كامبريدج، ماساتشوستس",
    "id": "Contoh: Jakarta, Indonesia"
  },
  "currently-studying": {
    "en": "I am currently studying here",
    "ar": "أنا أدرس حالياً هنا",
    "id": "Saya saat ini sedang belajar di sini"
  },
  "education-description-placeholder": {
    "en": "Write description about your education experience",
    "ar": "اكتب وصفاً عن تجربتك التعليمية",
    "id": "Tulis deskripsi tentang pengalaman pendidikan Anda"
  },
  "validation-university-min": {
    "en": "University must be at least 2 characters",
    "ar": "يجب أن تكون الجامعة على الأقل حرفين",
    "id": "Universitas minimal 2 karakter"
  },
  "validation-degree-min": {
    "en": "Degree must be at least 2 characters",
    "ar": "يجب أن تكون الدرجة العلمية على الأقل حرفين",
    "id": "Gelar minimal 2 karakter"
  },
  "validation-field-of-study-min": {
    "en": "Field of study must be at least 2 characters",
    "ar": "يجب أن يكون مجال الدراسة على الأقل حرفين",
    "id": "Bidang studi minimal 2 karakter"
  },
  "validation-location-min": {
    "en": "Location must be at least 2 characters",
    "ar": "يجب أن يكون الموقع على الأقل حرفين",
    "id": "Lokasi minimal 2 karakter"
  },
  "validation-end-date-education": {
    "en": "End date is required when not current education",
    "ar": "تاريخ الانتهاء مطلوب عندما لا يكون التعليم الحالي",
    "id": "Tanggal selesai wajib diisi jika bukan pendidikan saat ini"
  },
  "validation-start-date-future": {
    "en": "Start date cannot be in the future",
    "ar": "لا يمكن أن يكون تاريخ البدء في المستقبل",
    "id": "Tanggal mulai tidak boleh di masa depan"
  },
  "validation-end-date-future": {
    "en": "End date cannot be in the future",
    "ar": "لا يمكن أن يكون تاريخ الانتهاء في المستقبل",
    "id": "Tanggal selesai tidak boleh di masa depan"
  },
  "validation-end-before-start": {
    "en": "End date cannot be before start date",
    "ar": "لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ البدء",
    "id": "Tanggal selesai tidak boleh sebelum tanggal mulai"
  },
  "add-skill": {
    "en": "Add Skill",
    "ar": "إضافة مهارة",
    "id": "Tambah Keterampilan"
  },
  "update-skill": {
    "en": "Update Skill",
    "ar": "تحديث المهارة",
    "id": "Perbarui Keterampilan"
  },
  "add-skill-details": {
    "en": "Add your skill details",
    "ar": "أضف تفاصيل مهارتك",
    "id": "Tambahkan detail keterampilan Anda"
  },
  "update-skill-details": {
    "en": "Update your skill details",
    "ar": "حدث تفاصيل مهارتك",
    "id": "Perbarui detail keterampilan Anda"
  },
  "skill": {
    "en": "Skill",
    "ar": "المهارة",
    "id": "Keterampilan"
  },
  "skill-placeholder": {
    "en": "Skill (ex: Project Management)",
    "ar": "مثال: جافاسكريبت، رياكت، نود.جي.إس",
    "id": "Contoh: JavaScript, React, Node.js"
  },
  "validation-skill-min": {
    "en": "Skill must be at least 2 characters",
    "ar": "يجب أن تكون المهارة على الأقل حرفين",
    "id": "Keterampilan minimal 2 karakter"
  },
  "add-language": {
    "en": "Add Language",
    "ar": "إضافة لغة",
    "id": "Tambah Bahasa"
  },
  "update-language": {
    "en": "Update Language",
    "ar": "تحديث اللغة",
    "id": "Perbarui Bahasa"
  },
  "add-language-details": {
    "en": "Add your language details",
    "ar": "أضف تفاصيل لغتك",
    "id": "Tambahkan detail bahasa Anda"
  },
  "update-language-details": {
    "en": "Update your language details",
    "ar": "حدث تفاصيل لغتك",
    "id": "Perbarui detail bahasa Anda"
  },
  "language": {
    "en": "Language",
    "ar": "اللغة",
    "id": "Bahasa"
  },
  "language-placeholder": {
    "en": "Language (ex: English)",
    "ar": "اختر أو اكتب لغتك المفضلة",
    "id": "Pilih atau ketik bahasa pilihan Anda"
  },
  "proficiency-level": {
    "en": "Proficiency Level",
    "ar": "مستوى الإتقان",
    "id": "Tingkat Kemahiran"
  },
  "validation-language-min": {
    "en": "Language must be at least 2 characters",
    "ar": "يجب أن تكون اللغة على الأقل حرفين",
    "id": "Bahasa minimal 2 karakter"
  },
  "validation-rate-required": {
    "en": "Please select a rate level",
    "ar": "يرجى اختيار مستوى التقييم",
    "id": "Silakan pilih tingkat penilaian"
  },
  "back": {
    "en": "Back",
    "ar": "رجوع",
    "id": "Kembali"
  },
  "personal": {
    "en": "Personal",
    "ar": "شخصي",
    "id": "Personal"
  },
  "job": {
    "en": "Job",
    "ar": "وظيفة",
    "id": "Pekerjaan"
  },
  "no-personal-available": {
    "en": "No Personal available",
    "ar": "لا يوجد محتوى شخصي متاح",
    "id": "Tidak ada Personal tersedia"
  },
  "no-job-available": {
    "en": "No Job available",
    "ar": "لا توجد وظائف متاحة",
    "id": "Tidak ada Pekerjaan tersedia"
  },
  "about": {
    "en": "About",
    "ar": "حول",
    "id": "Tentang"
  },
  "not-specified": {
    "en": "Not specified",
    "ar": "غير محدد",
    "id": "Tidak ditentukan"
  },
  "experience": {
    "en": "Experience",
    "ar": "الخبرة",
    "id": "Pengalaman"
  },
  "no-experiences-available": {
    "en": "No experiences available",
    "ar": "لا توجد خبرات متاحة",
    "id": "Tidak ada pengalaman tersedia"
  },
  "present": {
    "en": "Present",
    "ar": "الحالي",
    "id": "Sekarang"
  },
  "no-education-available": {
    "en": "No education available",
    "ar": "لا يوجد تعليم متاح",
    "id": "Tidak ada pendidikan tersedia"
  },
  "projects": {
    "en": "Projects",
    "ar": "المشاريع",
    "id": "Proyek"
  },
  "no-projects-available": {
    "en": "No projects available",
    "ar": "لا توجد مشاريع متاحة",
    "id": "Tidak ada proyek tersedia"
  },
  "support-comments": {
    "en": "Support Comments",
    "ar": "تعليقات الدعم",
    "id": "Komentar Dukungan"
  },
  "no-data-available": {
    "en": "No data available",
    "ar": "لا توجد بيانات متاحة",
    "id": "Tidak ada data tersedia"
  },
  "show-your-support": {
    "en": "Show your support",
    "ar": "أظهر دعمك",
    "id": "Tunjukkan dukungan Anda"
  },
  "website": {
    "en": "Website",
    "ar": "الموقع الإلكتروني",
    "id": "Website"
  },
  "company-size": {
    "en": "Company Size",
    "ar": "حجم الشركة",
    "id": "Ukuran Perusahaan"
  },
  "headquarters": {
    "en": "Headquarters",
    "ar": "المقر الرئيسي",
    "id": "Kantor Pusat"
  },
  "founded": {
    "en": "Founded",
    "ar": "تأسست",
    "id": "Didirikan"
  },
  "add-project": {
    "en": "Add Project",
    "ar": "إضافة مشروع",
    "id": "Tambah Proyek"
  },
  "update-project": {
    "en": "Update Project",
    "ar": "تحديث المشروع",
    "id": "Perbarui Proyek"
  },
  "add-project-details": {
    "en": "Add your project details",
    "ar": "أضف تفاصيل مشروعك",
    "id": "Tambahkan detail proyek Anda"
  },
  "update-project-details": {
    "en": "Update your project details",
    "ar": "حدث تفاصيل مشروعك",
    "id": "Perbarui detail proyek Anda"
  },
  "edit-profile": {
    "en": "Edit Profile",
    "ar": "تعديل الملف الشخصي",
    "id": "Edit Profil"
  },
  "followers": {
    "en": "Followers",
    "ar": "المتابعون",
    "id": "Pengikut"
  },
  "following": {
    "en": "Following",
    "ar": "يتابع",
    "id": "Mengikuti"
  },
  "view": {
    "en": "View",
    "ar": "مشاهدة",
    "id": "Lihat"
  },
  "available": {
    "en": "Available",
    "ar": "متاح",
    "id": "Tersedia"
  },
  "not-available": {
    "en": "Not Available",
    "ar": "غير متاح",
    "id": "Tidak Tersedia"
  },
  "request-interview": {
    "en": "Request Interview",
    "ar": "طلب مقابلة",
    "id": "Minta Wawancara"
  },
  "added-to-compare-success": {
    "en": "{name} added to {jobTitle} successfully",
    "ar": "تمت إضافة {name} إلى {jobTitle} بنجاح",
    "id": "{name} berhasil ditambahkan ke {jobTitle}"
  },
  "update-company-size": {
    "en": "Update Company Size",
    "ar": "تحديث حجم الشركة",
    "id": "Perbarui Ukuran Perusahaan"
  },
  "update-company-size-description": {
    "en": "Update your company size",
    "ar": "حدث حجم شركتك",
    "id": "Perbarui ukuran perusahaan Anda"
  },
  "company-size-updated-success": {
    "en": "Company size updated successfully",
    "ar": "تم تحديث حجم الشركة بنجاح",
    "id": "Ukuran perusahaan berhasil diperbarui"
  },
  "company-size-update-failed": {
    "en": "Company size update failed",
    "ar": "فشل تحديث حجم الشركة",
    "id": "Gagal memperbarui ukuran perusahaan"
  },
  "updating": {
    "en": "Updating...",
    "ar": "جاري التحديث...",
    "id": "Memperbarui..."
  },
  "update-company-headquarters": {
    "en": "Update Company Headquarters",
    "ar": "تحديث المقر الرئيسي للشركة",
    "id": "Perbarui Kantor Pusat Perusahaan"
  },
  "update-company-headquarters-description": {
    "en": "Update your company headquarters",
    "ar": "حدث المقر الرئيسي لشركتك",
    "id": "Perbarui kantor pusat perusahaan Anda"
  },
  "company-headquarters-updated-success": {
    "en": "Company headquarters updated successfully",
    "ar": "تم تحديث المقر الرئيسي للشركة بنجاح",
    "id": "Kantor pusat perusahaan berhasil diperbarui"
  },
  "company-headquarters-update-failed": {
    "en": "Company headquarters update failed",
    "ar": "فشل تحديث المقر الرئيسي للشركة",
    "id": "Gagal memperbarui kantor pusat perusahaan"
  },
  "headquarters-placeholder": {
    "en": "e.g., San Francisco, CA",
    "ar": "مثال: الرياض، السعودية",
    "id": "contoh: Jakarta, Indonesia"
  },
  "update-company-website": {
    "en": "Update Company Website",
    "ar": "تحديث موقع الشركة",
    "id": "Perbarui Website Perusahaan"
  },
  "update-company-website-description": {
    "en": "Update your company website",
    "ar": "حدث موقع شركتك",
    "id": "Perbarui website perusahaan Anda"
  },
  "company-website-updated-success": {
    "en": "Company website updated successfully",
    "ar": "تم تحديث موقع الشركة بنجاح",
    "id": "Website perusahaan berhasil diperbarui"
  },
  "company-website-update-failed": {
    "en": "Company website update failed",
    "ar": "فشل تحديث موقع الشركة",
    "id": "Gagal memperbarui website perusahaan"
  },
  "website-placeholder": {
    "en": "https://example.com",
    "ar": "https://example.com",
    "id": "https://example.com"
  },
  "update-company-founded": {
    "en": "Update Company Founded",
    "ar": "تحديث تأسيس الشركة",
    "id": "Perbarui Tahun Berdiri Perusahaan"
  },
  "update-company-founded-description": {
    "en": "Update when your company was founded",
    "ar": "حدث تاريخ تأسيس شركتك",
    "id": "Perbarui tahun berdiri perusahaan Anda"
  },
  "company-founded-updated-success": {
    "en": "Company founded updated successfully",
    "ar": "تم تحديث تأسيس الشركة بنجاح",
    "id": "Tahun berdiri perusahaan berhasil diperbarui"
  },
  "company-founded-update-failed": {
    "en": "Company founded update failed",
    "ar": "فشل تحديث تأسيس الشركة",
    "id": "Gagal memperbarui tahun berdiri perusahaan"
  },
  "founded-placeholder": {
    "en": "e.g., 2020",
    "ar": "مثال: 2020",
    "id": "contoh: 2020"
  },
  "add-support-comment": {
    "en": "Add Support Comment",
    "ar": "إضافة تعليق دعم",
    "id": "Tambah Komentar Dukungan"
  },
  "add-support-comment-description": {
    "en": "Share your thoughts or provide support to this profile.",
    "ar": "شارك أفكارك أو قدم الدعم لهذا الملف الشخصي.",
    "id": "Bagikan pemikiran Anda atau berikan dukungan untuk profil ini."
  },
  "support-comment-placeholder": {
    "en": "Write your support comment here...",
    "ar": "اكتب تعليق الدعم الخاص بك هنا...",
    "id": "Tulis komentar dukungan Anda di sini..."
  },
  "submitting": {
    "en": "Submitting...",
    "ar": "جاري الإرسال...",
    "id": "Mengirim..."
  },
  "submit-comment": {
    "en": "Submit Comment",
    "ar": "إرسال التعليق",
    "id": "Kirim Komentar"
  },
  "optional": {
    "en": "Optional",
    "ar": "اختياري",
    "id": "Opsional"
  },
  "search-language": {
    "en": "Search language...",
    "ar": "ابحث عن لغة...",
    "id": "Cari bahasa..."
  },
  "no-language-found": {
    "en": "No language found",
    "ar": "لم يتم العثور على لغة",
    "id": "Bahasa tidak ditemukan"
  },
  "type-to-search": {
    "en": "Type to search languages",
    "ar": "اكتب للبحث عن اللغات",
    "id": "Ketik untuk mencari bahasa"
  },
  "delete-video-title": {
    "en": "Delete Video",
    "ar": "حذف الفيديو",
    "id": "Hapus Video"
  },
  "delete-video-subtitle": {
    "en": "Are you sure you want to delete this video? This action cannot be undone.",
    "ar": "هل أنت متأكد أنك تريد حذف هذا الفيديو؟ لا يمكن التراجع عن هذا الإجراء.",
    "id": "Apakah Anda yakin ingin menghapus video ini? Tindakan ini tidak dapat dibatalkan."
  }
}
